export type AccessTier = 'non-donor' | 'donor' | 'premium' | 'elite'

export const getUserPrivilegeName = (privileges: number) => {
  switch (privileges) {
    case 1:
      return 'Standard'
    case 2:
      return 'Premium'
    case 3:
      return 'Elite'
    default:
      return ''
  }
}

export const getContentAccessLevel = (
  privileges: number,
  accessLevel: 'public' | 'standard' | 'premium' | 'elite',
) => {
  if (accessLevel === 'public') return true
  if (accessLevel === 'standard' && privileges >= 1) return true
  if (accessLevel === 'premium' && privileges >= 2) return true
  if (accessLevel === 'elite' && privileges >= 3) return true
  return false
}

export const getUserPrivilegeTag = (privileges: number) => {
  switch (privileges) {
    case 0:
      return ['payitforward', 'PIFfree']
    case 1:
      return ['payitforward', 'PIFstandard']
    case 2:
      return ['payitforward', 'PIFpremium']
    case 3:
      return ['payitforward', 'PIFelite']
    default:
      return ['payitforward']
  }
}

export const getAccessTierByPrivilege = (privilege: number): AccessTier => {
  if (privilege >= 3) return 'elite'
  if (privilege >= 2) return 'premium'
  if (privilege >= 1) return 'donor'
  return 'non-donor'
}
